module.exports = __webpack_public_path__ + "img/facebook.b1a8496e.svg";